import { useMemo, type CSSProperties } from "react";
import { range, rand, pick } from "../utils/random";
import type { EffectProps } from "./types";

const COLORS = [
  "#ff5a8a",
  "#ff85a1",
  "#ffd966",
  "#a78bff",
  "#7ed6df",
  "#9ee493",
  "#ffb3c1",
  "#ffe066",
];

export function Confetti({ count = 80 }: EffectProps = {}) {
  const pieces = useMemo(
    () =>
      range(count).map(i => ({
        id: i,
        left: `${rand(0, 100)}vw`,
        color: pick(COLORS),
        width: `${rand(6, 14)}px`,
        height: `${rand(10, 20)}px`,
        fallDuration: `${rand(4, 9)}s`,
        spinDuration: `${rand(1.5, 4)}s`,
        delay: `${rand(-9, 0)}s`,
      })),
    [count],
  );

  return (
    <div className="fx-layer" aria-hidden>
      {pieces.map(p => (
        <span
          key={p.id}
          className="fx-particle fx-confetti"
          style={
            {
              left: p.left,
              top: 0,
              width: p.width,
              height: p.height,
              background: p.color,
              animationDuration: `${p.fallDuration}, ${p.spinDuration}`,
              animationDelay: `${p.delay}, ${p.delay}`,
            } as CSSProperties
          }
        />
      ))}
    </div>
  );
}
